module.exports = __webpack_public_path__ + "img/badge200.93f24212.png";